import React from 'react';
import styled from 'styled-components';
import * as size from '@constant/size';
import Gap from '@component/common/gap';
import Scroll, { ScrollContainer } from '@component/common/scroll';

interface IProps {
  // 스크롤 본문 영역
  content: React.ReactNode;
  // 하단 고정 영역 (예: "보러가기" / "닫기" 버튼). 있을 때만 본문과의 여백(Gap)과 함께 렌더된다.
  footer?: React.ReactNode;
}

const Wrapper = styled.div`
  position: relative;
  height: ${size.TOAST_HEIGHT};
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
`;

// explanation 계열 토스트의 layout 셸. 스크롤 본문(content) + 선택적 하단 footer만 책임진다.
const ExplanationToast: React.FC<IProps> = ({ content, footer }) => {
  return (
    <Wrapper>
      <ScrollContainer>
        <Scroll direction='y' height='100%'>
          {content}
        </Scroll>
      </ScrollContainer>
      {footer && (
        <>
          <Gap height={size.MARGIN_1} />
          {footer}
        </>
      )}
    </Wrapper>
  );
};

export default ExplanationToast;
